exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-60a09b70]{font-family:Open Sans,sans-serif;font-size:.8125rem;color:#fff;color:#41aaaa;margin:15px 0 10px 5px}", ""]);

// exports
